<div class="checkbox">
  <div class="checkbox__field">
    <input
      [(ngModel)]="checked"
      class="checkbox__input peer"
      type="checkbox"
      [name]="label()"
      [disabled]="disabled"
      [checked]="checked" />

    <span class="checkbox__icon">
      <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0.75 4.50773L3.58 7.33773L9.25 1.67773"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </span>
  </div>

  <label class="checkbox__label" [for]="label()"
    >{{ label() | translate }}
  </label>
</div>
